import { isThisQuarter } from "date-fns";
import { ContractsConfiguration } from "./ContractsConfiguration";

export class ContractsApplication {
    private currentContainer: JQuery;
    private configuration: ContractsConfiguration;
    private fileUploadButton: JQuery;
    private fileUploadArea: JQuery;
    private uploadedFileName: JQuery;
    private saveButton: JQuery;

    constructor(private container: JQuery) {
        this.currentContainer = container;
        this.configuration = new ContractsConfiguration(container);
        this.fileUploadButton = $('#ContractFileButton');
        this.fileUploadArea = $('#ContractData');
        this.uploadedFileName = $('#UploadedFileName');
        this.saveButton = $('.add-button');
        this.initialize();
    }

    fileUploadClick(evt) {
        let that = this;
        this.fileUploadArea.on('change', function(e) {
            var file = (<HTMLInputElement>e.target).files[0];
            that.saveButton.show();
            that.fileUploadButton.hide();
            that.uploadedFileName.html(file.name);
            that.uploadedFileName.show();
        });
        
        this.fileUploadArea.click();
    }

    private initialize() {
        this.fileUploadArea.hide();
        this.uploadedFileName.hide();
        this.saveButton.hide();
        
        let that = this;
        this.fileUploadButton.on('click', function(evt) {
            evt.preventDefault();
            that.fileUploadClick(evt);
        });
        
        $('.download_blank').on('click', function(e) {
           e.preventDefault();
           window.open($(e.currentTarget).attr('href'), '_blank');
        });
    }
}